import apiClient from "./client";
import type { GetSitesParams, SitesListResponse } from "../types/site";

export const getSites = async (
  params: GetSitesParams
): Promise<SitesListResponse> => {
  const { data } = await apiClient.get<SitesListResponse>("/sites", {
    params: {
      display_code: params.display_code,
      name: params.name,
      pref: params.pref,
      division_code: params.division_code,
      m_branch_id: params.m_branch_id,
      m_customer_id: params.m_customer_id,
      owned_kind: params.owned_kind,
      order: params.order,
      sort: params.sort,
      page: params.page,
      limit: params.limit,
    },
  });
  return data;
};
